<app-page-header>
    {{ 'Feature Flags' }}
    <button *ngIf="dataTable.hasData"
            mat-fab extended disableRipple color="primary"
            [attr.aria-label]="'Add feature flag'"
            (click)="createFlag()">
        <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
        {{ 'Feature Flag' }}
    </button>
</app-page-header>

<app-table #dataTable
           class="pmc-feature-flags-table"
           [columnMap]="columnMap"
           [type]="tableType"
           [hasFilters]="false">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [svgIcon]="'v2:fi-br-flag'">
                <span avatarTitle>{{ row.name }}</span>
                {{ row.createdAt | legfiDate }}
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [svgIcon]="'v2:fi-br-flag'">
                <span avatarTitle>{{ row.name }}</span>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="enabled">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[2].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.createdAt">
            {{ row.createdAt | legfiDate }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef justifyRightCell>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" justifyRightCell>
            <button [matMenuTriggerFor]="rowMenu" mat-icon-button linkButton disableRipple>
                <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                <button (click)="deleteFlag(row)" mat-menu-item>{{ 'Delete Flag' }}</button>
            </mat-menu>
        </mat-cell>
    </ng-container>

    <app-empty-state>
        <span emptyStateTitle>{{ 'No feature flags so far...' }}</span>
        <button mat-fab extended disableRipple color="primary"
                [attr.aria-label]="'Add feature flag'"
                (click)="createFlag()">
            <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
            {{ 'Feature Flag' }}
        </button>
    </app-empty-state>
</app-table>
